module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.showData.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "归属方:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.AgentStyleName) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属代理商:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.agent) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开课园所:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.school) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.PackageName) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付对象:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.PayObjectName) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开课班级数:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.ClassNum) + "\n            ")]), _vm._v(" "), _vm._l((_vm.form.ClassList), function(item, index) {
    return _c('el-form-item', {
      attrs: {
        "label": '班级' + (index + 1) + ':'
      }
    }, [_vm._v("\n                " + _vm._s(item.ClassName) + "\n            ")])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "暑期艺术亲子活动包加购班级:",
      "label-width": "200px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.MoreClassNum) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置课程"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.courses,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "课程类型",
      "prop": "ProName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "ProNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.MoreClassNum > 0),
      expression: "form.MoreClassNum>0"
    }],
    attrs: {
      "label": "配置艺术亲子活动材料包:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.form.GoodsList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "prop": "ProductName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "ProNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单价格:"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.form.OrderPrice) + "元")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.MoreClassNum > 0),
      expression: "form.MoreClassNum>0"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择收货地址:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeList))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人及联系方式:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeListName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送方式:",
      "label-width": "150px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.form.SendModeName) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送支付方式:",
      "label-width": "150px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.form.PayModeName) + "\n                ")])], 1), _vm._v(" "), _vm._l((_vm.form.ListMeetPay), function(item, index) {
    return _c('el-row', [_c('el-form-item', {
      attrs: {
        "label": '支付方式-' + (index + 1)
      }
    }, [_c('span', [_vm._v(_vm._s(item.PayWayName))])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.PayWay !== 6 && item.PayWay !== 9),
        expression: "item.PayWay!==6&&item.PayWay!==9"
      }],
      attrs: {
        "label": "支付金额："
      }
    }, [_c('span', [_vm._v(_vm._s(item.OrderActualPrice))])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.VoucherPic.length > 0),
        expression: "item.VoucherPic.length>0"
      }],
      attrs: {
        "label": "支付凭证"
      }
    }, _vm._l((item.VoucherPic), function(item2) {
      return _c('div', {
        attrs: {
          "id": "ImgPrev"
        }
      }, [_c('div', {
        staticClass: "post-format-content"
      }, [_c('div', {
        staticClass: "post-thumbnail"
      }, [_c('img', {
        staticClass: "attachment-thumbnail wp-post-image",
        attrs: {
          "id": "myProPic",
          "src": item2.Url
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "content-wrap"
      }, [_c('span', {
        staticClass: "entry-title"
      }, [_c('span', {
        staticClass: "featured-image",
        on: {
          "click": function($event) {
            _vm.showImgView(item2)
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-view"
      })])])])])])
    })), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.Trade_No !== ''),
        expression: "item.Trade_No!==''"
      }],
      attrs: {
        "label": "支付凭证单号："
      }
    }, [_c('span', [_vm._v(_vm._s(item.Trade_No))])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.PayWay == 8),
        expression: "item.PayWay==8"
      }],
      attrs: {
        "label": "支付说明："
      }
    }, [_c('span', [_vm._v(_vm._s(item.PayRemark))])])], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单备注："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.OrderRemark) + "\n            ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.AddDialogVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fdd8fac2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchoolOrder/components/SummerSchoolOrderView/index.vue
// module id = 1586
// module chunks = 1